import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';

function Textarea({ additionalClasses, variant, ...rest }) {

    let classes = "border-1 rounded-md w-full outline-none focus:outline-none ring-0 focus:ring-0 focus:border-purple "
        + (!!additionalClasses && additionalClasses);

    if (!!variant) {
        switch (variant) {
            case "primary":
                classes += " border-purple";
                break;
            default:
                classes += " border-gray-lighter";
                break;
        }
    }

    return (
        <TextareaAutosize className={classes} {...rest} />
    );
}

export default Textarea;
